import React from "react";
import '../assets/styles/Project.scss';

function Project() {
    const projects = [
        {
            id: 1,
            title: "Enterprise E-Wallet Platform",
            company: "JamboPay",
            description: "Redesigned core e-wallet platform serving Uber Kenya, E-Citizen, and Kenya Ports Authority.",
            tech: [".NET Core", "Kafka", "MS SQL Server", "REST API"],
        },
        {
            id: 2,
            title: "Revenue Collection Platform",
            company: "Kenya Ports Authority",
            description: "Built high-availability financial transaction services with event-driven architecture.",
            tech: ["C#", "Kafka", "Hangfire", "PostgreSQL", "Azure"],
        },
        {
            id: 3,
            title: "Payment Gateway Integration",
            company: "Centrino Technologies",
            description: "Integrated multiple payment gateways into core banking systems with real-time monitoring.",
            tech: ["ASP.NET Core", "REST API", "SQL Server"],
        },
        {
            id: 4,
            title: "Insurance Policy Management System",
            company: "ICEA LION Insurance",
            description: "Developed backend systems for policy management and customer self-service.",
            tech: ["C#", "MS SQL Server", "Entity Framework"],
        }
    ];

    return (
        <div className="projects-container" id="projects">
            <h1 className="projects-title">Featured Projects</h1>
            <div className="projects-grid">
                {projects.map((project) => (
                    <div key={project.id} className="project-card">
                        <div className="project-header">
                            <h3 className="project-title">{project.title}</h3>
                            <span className="project-company">{project.company}</span>
                        </div>
                        
                        <p className="project-description">{project.description}</p>
                        
                        <div className="project-tech">
                            {project.tech.map((tech, index) => (
                                <span key={index} className="tech-tag">{tech}</span>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Project;